document.addEventListener('DOMContentLoaded', async function(){
    enableSetGuideCollapse();
    customLineItemVariantChange();
});

// window.addEventListener('resize', function(){
//     enableSetGuideCollapse();
// });

function enableSetGuideCollapse() {
    var toggles = document.querySelectorAll('.c-guide-heading');
    if(toggles.length == 0) return;

    toggles.forEach(toggle => {
        const guideBlock = toggle.parentElement;
        guideBlock.classList.remove('active');
    });

    document.addEventListener('click', function(e){
        const target = e.target.closest('.c-guide-heading');
        if(!target || window.innerWidth > 999) return;

        target.parentElement.classList.toggle('active');
    });
}

async function customLineItemVariantChange() {
    document.addEventListener("change", async function(e){
        const target = e.target;
        if(!target.classList.contains("line-item-variant-change")) return;

        document.querySelector("cart-drawer")?.classList.add("is-updating");

        const variant_to_add = target.value;
        const variant_to_remove = target.getAttribute("data-selected");

        try {
            // 1️⃣ Get current cart first
            const cartRes = await fetch("/cart.js");
            const cart = await cartRes.json();

            let addQty = 0;
            let removeQty = 0;

            cart.items.forEach(item => {
                if (item.id == variant_to_add) {
                    addQty = item.quantity;
                }
                if (item.id == variant_to_remove) {
                    removeQty = item.quantity;
                }
            });

            const updates = {};

            // 2️⃣ Increase target variant by 1
            updates[variant_to_add] = addQty + removeQty;

            // 3️⃣ Decrease old variant by 1
            if (removeQty > 1) {
                updates[variant_to_remove] = 0;
            } else {
                updates[variant_to_remove] = 0;
            }

            let sectionsToBundle = [document.querySelector(".shopify-section--cart-drawer").getAttribute("id").replace("shopify-section-", "")];

            const res = await fetch("/cart/update.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                },
                body: JSON.stringify({ 
                    updates,
                    sections: sectionsToBundle.join(","),
                    sections_url: window.location.pathname
                }),
            });

            if (!res.ok) {
                throw new Error(`Cart update failed: ${res.status}`);
            }

            const updatedCart = await res.json();
            document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                bubbles: true,
                detail: {
                    baseEvent: "line-item:change",
                    cart: updatedCart
                }
            }));
            document.dispatchEvent(new CustomEvent("cart:refresh", { detail: updatedCart }));

        } catch (err) {
            console.error("Update failed:", err);
        }
    });
}